import React from "react";
import PropTypes from "prop-types";

const CELL_BACKGROUND = {
  backgroundColor: 'var(--sl-bg-secondary, #fafafa)',
  borderBottom: '1px solid var(--sl-border-secondary, #e9eaeb)',
};

const SectionHeader = ({ title }) => (
  <tr>
    <td
      style={{
        paddingLeft: 24,
        paddingTop: 16,
        paddingBottom: 8,
        fontSize: 13,
        fontWeight: 600,
        color: 'var(--sl-text-secondary, #414651)',
        ...CELL_BACKGROUND,
      }}
    >
      {title}
    </td>
    <td style={CELL_BACKGROUND} />
    <td style={CELL_BACKGROUND} />
  </tr>
);

SectionHeader.propTypes = {
  title: PropTypes.string.isRequired,
};

export default SectionHeader;
